import React from 'react';
import ModalForm from '../Reusable/ModalForm';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateVehicleModel } from '../../enums/VehicleModelEnums';
import { useSelector } from 'react-redux'; // Dodato

const ModalForUpdateVehicleModel = ({
  model,
  updateVehicleModel,
  handleClose,
  show,
  vehicleModelReducer,
}) => {
  const { error } = vehicleModelReducer;

 
  const brandReducer = useSelector((state) => state.brand);
  const { brandList } = brandReducer;

  const fields = [
    {
      name: 'brand.id', 
      label: 'Brend',
      type: 'select',
      options: brandList?.map((b) => ({
        value: b.id,
        label: b.brandName,
      })),
    },
    {
      name: 'modelName',
      label: ModalForAddOrUpdateVehicleModel.modelNamePlaceholder,
      type: 'text',
    },
    
  ];

  const initialValues = {
    modelName: model.modelName,
    ['brand.id']: model.brand?.id, 
  };

  const handleSubmit = (formData) => {
  
    const updatedVehicleModel = {
      id: model.id,
      modelName: formData.modelName,
      brand: {
        id: formData['brand.id'],
      },
    };
    updateVehicleModel(updatedVehicleModel);
  };

  return (
    <ModalForm
      open={show}
      onClose={handleClose}
      title={ModalForAddOrUpdateVehicleModel.titleForUpdateVehicleModel}
      fields={fields}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      error={error}
      submitLabel={SubmitButton.update}
    />
  );
};

export default ModalForUpdateVehicleModel;